import React, { useState } from 'react'
import styles from './styles.module.css'
import { useTranslation } from 'react-i18next'
import Row from '../Row'
import SampleCodeLoader from '../SampleCode/Loader'

import TabDescription from './TabDescription'
import TabItem from '../TabItem'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const Tab = ({ children, src, ...rest }) => {
  const [selected, setSelected] = useState(0)
  const [showMore, setShowMore] = useState(false)
  const { t } = useTranslation()
  const iconTab = showMore ? 'minus-circle' : 'plus-circle'

  const content = Array.isArray(children) ? children : [children]

  const menus = content
    .filter(menu => menu?.type === TabItem && menu?.props?.title)
    .map((menu, index) => ({
      ...menu,
      props: { ...menu.props, onClick: () => setSelected(index), selected: selected === index, id: `tab-item-${index}` },
    }))

  const learnMore = content.filter(menu => menu?.type === TabDescription)

  return (
    <Row>
      <>
        <ul className={styles.tabMenu} {...rest}>
          {menus}
          {/* eslint-disable-next-line */}
          {!!learnMore.length && (
            <li className={styles.tabMore}>
              <button onClick={() => setShowMore(isShowing => !isShowing)}>
                <FontAwesomeIcon data-testid="learnMore-button-icon" icon={['far', iconTab]} />
                {t('general.learnMore')}
              </button>
            </li>
          )}
        </ul>

        {!!learnMore.length && showMore && learnMore}

        {!!menus.length && menus[selected].props.children}
      </>
      {!!menus.length && !!menus[selected].props?.src && <SampleCodeLoader src={menus[selected].props.src} />}
    </Row>
  )
}

export default Tab
